import axios from 'axios';
import { AuthRepository } from 'features/auth/repositories/AuthRepository';
import config from '../config';

const instance = axios.create({ baseURL: config.api });

instance.interceptors.request.use(async (axiosConfig) => {
  const repository = new AuthRepository();
  const token = await repository.getAuthenticatedUserToken();
  if (token) {
    axiosConfig.headers.authorization = `Bearer ${token}`;
  }
  return axiosConfig;
});

instance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error?.config;

    if (
      error?.response?.status === 401 &&
      originalRequest &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;

      const repository = new AuthRepository();
      const token = await repository.getAuthenticatedUserToken();

      if (token) {
        originalRequest.headers.authorization = `Bearer ${token}`;
        return instance(originalRequest);
      }

      await repository.logoutWithoutRedirect();
      window.location.href = '/login';
    }

    throw error;
  }
);

export default instance;
